import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDownToBracketIcon, CheckIcon, ClockIcon, FlagIcon, XIcon } from '@repo/icons';
import { Card, Badge, Button } from '@repo/ui';
import { formatDateYmd } from '@repo/date-time';
import { downloadFile } from '@repo/file-handling';
import PaymentMethodDisplay from '../payment/PaymentMethodDisplay';
import { getLabels } from '../../labels';
import ReservationPaymentSection from './ReservationPaymentSection';
const PAYMENT_STATUS_BADGE = {
    succeeded: {
        color: 'success',
        icon: CheckIcon,
        labelTranslationKey: 'paid',
        testIdSuffix: 'succeeded',
    },
    pending: {
        color: 'warning',
        icon: ClockIcon,
        labelTranslationKey: 'pending',
        testIdSuffix: 'pending',
    },
    failed: {
        color: 'danger',
        icon: XIcon,
        labelTranslationKey: 'failed',
        testIdSuffix: 'failed',
    },
    refunded: {
        color: 'gray',
        icon: FlagIcon,
        labelTranslationKey: 'refunded',
        testIdSuffix: 'refunded',
    },
};
export default function ReservationPaymentCard({ price, parkDuration, testId, method, document, paymentStatus, paymentCreatedAt, collapsible, }) {
    const handleDownload = async () => {
        if (!document)
            return;
        await downloadFile(document.url, `${document.type}-${formatDateYmd(paymentCreatedAt ?? new Date())}.pdf`);
    };
    const badgeConfig = paymentStatus ? PAYMENT_STATUS_BADGE[paymentStatus] : undefined;
    const paymentLabel = document
        ? {
            invoice: getLabels().reservation.payment.download_invoice,
            receipt: getLabels().reservation.payment.download_receipt,
            confirmation: getLabels().reservation.payment.download_confirmation,
        }[document.type]
        : undefined;
    const paymentTestId = document
        ? {
            invoice: testId.append('downloadInvoice'),
            receipt: testId.append('downloadReceipt'),
            confirmation: testId.append('downloadConfirmation'),
        }[document.type]
        : undefined;
    return (_jsxs(Card, { title: getLabels().reservation.payment.title, collapsible: collapsible, testId: testId.append('paymentCollapse'), children: [_jsx(ReservationPaymentSection, { testId: testId.append('payment'), flatPrice: price, parkDuration: parkDuration }), (method || badgeConfig) && (_jsxs("div", { className: "xs:flex-row flex flex-col items-center justify-between gap-2", children: [method && _jsx(PaymentMethodDisplay, { method: method, testId: testId.append('paymentMethod') }), badgeConfig && (_jsx(Badge, { color: badgeConfig.color, leftIcon: badgeConfig.icon, label: getLabels().reservation.payment[badgeConfig.labelTranslationKey], testId: testId.append(badgeConfig.testIdSuffix) }))] })), document && paymentTestId && (_jsx(Button, { color: "brand", size: "sm", leftIcon: ArrowDownToBracketIcon, label: paymentLabel, onClick: handleDownload, testId: paymentTestId }))] }));
}
